import { IconWrapper } from '../runtime';
export default IconWrapper('folder', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 6.24979H14M12.75 13.2498H3.25C2.42157 13.2498 1.75 12.5782 1.75 11.7498V3.24979C1.75 2.42136 2.42157 1.74979 3.25 1.74979H6.4C6.46491 1.74979 6.52807 1.77084 6.58 1.80979L8.5 3.24979H12.75C13.5784 3.24979 14.25 3.92136 14.25 4.74979V11.7498C14.25 12.5782 13.5784 13.2498 12.75 13.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});